export const KEY_ADDRS = {
  CLAIMS_ESCROW: '0x501aCEA73C7f4E5fB6Bce5A53603DA611F6A854C',
  CPFARM: '0x501ACeb4D4C2CB7E4b07b53fbe644f3e51D25A3e',
  FARM_CONTROLLER: '0x501aCEDD1a697654d5F53514FF09eDECD3ca6D95',
  FARM_REWARDS: '0x501acEA5a5B21f863215385C1EDaA46eeB562328',
  POLICY_MANAGER: '0x501ace5E9f058bB2E851675BB3fA104Da6E3A22C',
  RISK_MANAGER: '0x501ACe9eE0AB4D2D4204Bcf3bE6eE13Fd6337804',
  SOLACE: '0x501acE9c35E60f03A2af4d484f49F9B1EFde9f40',
  XSOLACE_V1: '0x501AcE5aC3Af20F49D53242B6D208f3B91cfc411',
  XSOLACE: '0x501ACe802447B1Ed4Aae36EA830BFBde19afbbF9',
  XSLOCKER: '0x501Ace47c5b0C2099C4464f681c3fa2ECD3146C1',
  STAKING_REWARDS: '0x501ace3D42f9c8723B108D4fBE29989060a91411',
  XSOLACE_MIGRATOR: '0x501aCe6Ce61D1fFecdade5BB04539809Bc301FeE',
  VAULT: '0x501AcEe83a6f269B77c167c6701843D454E2EFA0',
  BOND_DEPO: '0x501ACe81445C57fC438B358F861d3774199cE13c',
}

export const PRODUCT_ADDRS = {
  AAVE_PRODUCT: '0x501AcE1564b4EF3c653A635C5c42A9018191b305',
  COMPOUND_PRODUCT: '0x501aCe743d0Aa994Fb2297f2D7BD9fD49B10816b',
  CURVE_PRODUCT: '0x501aCef2EA19c9a622080F129cEcFEe62a2f8aD5',
  LIQUITY_PRODUCT: '0x501aCE84be589758f88512E02aE9969d490fAcbC',
  SUSHISWAP_PRODUCT: '0x501ace36ee92f290a8c41e344eaa4d15da030818',
  UNISWAPV2_PRODUCT: '0x501aCED74C9A935A2E3908a8BEBF1E0248ACF2A8',
  UNISWAPV3_PRODUCT: '0x501Ace6c657A9b53B320780068Fd99894d5795Cb',
  YEARN_PRODUCT: '0x501ace86502900EC5f3E6A011004B7b9D04b8941',
}

export const TELLER_ADDRS = {
  DAI_TELLER: '0x501AcE5FEe0337e13A442Cb5e15728EE0e8b3F29',
  ETH_TELLER: '0x501ace68E20c29629E690D86E54E79719e2Fc5e8',
  USDC_TELLER: '0x501aCE044AE4E11183026659EE3B0E3b0Df04d7F',
  USDT_TELLER: '0x501acE6061D6176Da12FCBa36Bc85B2fc3FFd5e3',
  SOLACE_USDC_SLP_TELLER: '0x501acEb253483BD58773365334DEf095304CddAE',
  WBTC_TELLER: '0x501aCE2f3b5B8f645E67556Df77ac4c3081D84C7',
  SCP_TELLER: '0x501aCE163FfaCDa6584D75b274eD23155BFf4812',
}
